import { AiApiError, type AiApi } from "./types";

const fail = async (): Promise<never> => {
  throw new AiApiError("ai_unavailable");
};
/** Before sign-in and in unit tests without a provider. */
export const unavailableAiApi = (): AiApi => ({
  draft: fail,
  rejectDraft: fail,
  rebuildStyle: fail,
  saveStyle: fail,
  cancelFollowUp: fail,
  moveFollowUpTouch: fail,
  writeFollowUpTouchNow: fail,
});
